import { onboardingProps, useOnboardingStore } from "@/store/onboardingStore";
import { ONBOARDING_STEPS, StepName } from "@jurni/schemas";
import { DarkCard } from "./dark-card";
import { useEffect, useMemo, useRef, useState } from "react";
import { LoadingSvg } from "./loading-svg";

const getLoadingTexts = (step: StepName | null) => {
  if (!step) return null;
  switch (step) {
    case ONBOARDING_STEPS.WAITING_BRAND_CUSTOMIZATION:
      return [
        "Syncing core brand assets",
        "Setting up your brand workspace",
        "Preparing your funnel environment",
      ];
    default:
      return null;
  }
};

export const LoadingCard = () => {
  const [textIndex, setTextIndex] = useState<number>(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const onboardingLoadingState = useOnboardingStore(
    onboardingProps.onboardingLoadingState,
  );
  const loadingTexts = useMemo(
    () => getLoadingTexts(onboardingLoadingState),
    [onboardingLoadingState],
  );
  const showLoadingTexts = !!loadingTexts;

  useEffect(() => {
    if (showLoadingTexts && loadingTexts) {
      setTextIndex(0);
      intervalRef.current = setInterval(() => {
        setTextIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
      }, 4000);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [showLoadingTexts, loadingTexts]);

  return (
    <div className="relative flex h-full w-full max-w-full items-center justify-center p-4">
      <DarkCard className="h-[370px] w-[calc(100vw-40px)] max-w-[572px] lg:w-[572px]">
        <div className="flex flex-col items-center justify-center">
          <LoadingSvg isLoading />
          <div className=" text-center">
            <div className="letter-spacing-widest mb-2 text-xs tracking-widest text-gray-400 sm:text-sm">
              DETECTING
            </div>
            <p
              key={textIndex}
              className="text-center text-lg font-medium transition-all duration-500 animate-in fade-in sm:text-2xl"
            >
              {showLoadingTexts ? loadingTexts[textIndex] : ""}
            </p>
          </div>
        </div>
      </DarkCard>
    </div>
  );
};
